import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FormControlErrorMessageModule } from '@portal-core/forms/components/form-control-error-message/form-control-error-message.module';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { TeamAvatarModule } from '@portal-core/teams/components/team-avatar/team-avatar.module';
import { TeamsSelectListModule } from '@portal-core/teams/components/teams-select-list/teams-select-list.module';
import { AutocompleteInputModule } from '@portal-core/ui/autocomplete/components/autocomplete-input/autocomplete-input.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { LicenseSsoFormComponent } from './license-sso-form.component';

@NgModule({
  declarations: [
    LicenseSsoFormComponent
  ],
  imports: [
    McColorModule,
    AutocompleteInputModule,
    CommonModule,
    ErrorsExpansionPanelModule,
    FormsModule,
    FormControlErrorMessageModule,
    LoaderModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatRadioModule,
    MatSnackBarModule,
    ReactiveFormsModule,
    TeamsSelectListModule,
    TeamAvatarModule
  ],
  exports: [
    LicenseSsoFormComponent
  ]
})
export class LicenseSsoFormModule { }
